import React, {FC, useState} from 'react';
import {DataType} from '../../../const/crud';
import {Company} from '../../../models/Company';
import {CRUDType} from '../../Data/DataConst';

interface XeroProps {
  company: Company;
  crudAction;
}

const XeroAuth: FC<XeroProps> = ({company, crudAction}) => {
  const [authUrl, setAuthUrl] = useState<string>();

  const status = !!company.integrations?.xero?.access_token;

  return (
    <div className={'IntegrationWrapper'}>
      <h1>Xero Integration</h1>
      <p>
        Status: <span className={`StatusIcon ${status ? 'green' : 'red'}`} />
        <strong>{status ? 'Connected' : 'Not Connected'}</strong>
      </p>

      {status && (
        <button
          className={'ui icon button ui primary redButton'}
          onClick={async () => {
            delete company.integrations.xero;

            await crudAction(CRUDType.UPDATE, DataType.COMPANY, company, true);
          }}
        >
          Disconnect Xero
        </button>
      )}

      {!status && (
        <>
          <h2>To Connect Xero</h2>

          <div className={'Steps'}>
            <div className={'Step'}>
              <p style={{margin: `0 10px 0 0`}}>
                <strong>Step 1</strong>
              </p>
              <button
                className={'ui icon button ui primary'}
                disabled={!!authUrl}
                onClick={async () => {
                  const authUrlResponse = await crudAction(
                    CRUDType.AUTH_XERO,
                    DataType.COMPANY,
                    company._id,
                    false,
                  );

                  setAuthUrl(authUrlResponse.data);
                }}
              >
                Start Authorisation
              </button>
            </div>

            <div className={'Step'}>
              <p style={{margin: `0 10px 0 0`}}>
                <strong>Step 2</strong>
              </p>
              <a
                className={`ui icon button ui primary ${
                  authUrl ? '' : 'disabled'
                }`}
                href={authUrl}
              >
                Connect Your Xero Account
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default XeroAuth;
